import { useMemo } from 'react';
import { useAgentOptions } from '@cotera/client/app/v1/trigger/hooks';
import type { AgentNodeLiveMeta } from './components/node/agent-node-display';

/** Agents-list metadata for workflow chrome while per-agent watchables hydrate. */
export function useAgentLiveMeta(
  agentId: string | undefined
): AgentNodeLiveMeta | undefined {
  const agents = useAgentOptions();
  return useMemo(() => {
    if (agentId === undefined || agentId === '') {
      return undefined;
    }
    const agent = agents.find((entry) => entry.id === agentId);
    if (agent === undefined) {
      return undefined;
    }
    return {
      name: agent.title ?? agent.agentKey,
      model: agent.model,
      description: agent.description,
    };
  }, [agents, agentId]);
}
